import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Progress/progress';
import { css } from '@patternfly/react-styles';
import { ProgressContainer, ProgressMeasureLocation } from './ProgressContainer';
import { getUniqueId } from '../../helpers/util';
export var ProgressSize;

(function (ProgressSize) {
  ProgressSize["sm"] = "sm";
  ProgressSize["md"] = "md";
  ProgressSize["lg"] = "lg";
})(ProgressSize || (ProgressSize = {}));

export var Progress =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Progress, _React$Component);

  function Progress() {
    var _this;

    _classCallCheck(this, Progress);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Progress).apply(this, arguments));
    _this.id = _this.props.id || getUniqueId();
    return _this;
  }

  _createClass(Progress, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          id = _a.id,
          size = _a.size,
          className = _a.className,
          value = _a.value,
          title = _a.title,
          label = _a.label,
          variant = _a.variant,
          measureLocation = _a.measureLocation,
          min = _a.min,
          max = _a.max,
          valueText = _a.valueText,
          props = __rest(_a, ["id", "size", "className", "value", "title", "label", "variant", "measureLocation", "min", "max", "valueText"]);

      var progressBarAriaProps = {
        'aria-labelledby': "".concat(this.id, "-description"),
        'aria-valuemin': min,
        'aria-valuenow': value,
        'aria-valuemax': max
      };

      if (valueText) {
        progressBarAriaProps['aria-valuetext'] = valueText;
      }

      var scaledValue = Math.min(100, Math.max(0, Math.floor((value - min) / (max - min) * 100)));
      return React.createElement("div", Object.assign({}, props, {
        className: css(styles.progress, styles.modifiers[variant], ['inside', 'outside'].includes(measureLocation) && styles.modifiers[measureLocation], measureLocation === 'inside' ? styles.modifiers[ProgressSize.lg] : styles.modifiers[size], !title && styles.modifiers.singleline, className),
        id: this.id
      }), React.createElement(ProgressContainer, {
        parentId: this.id,
        value: scaledValue,
        title: title,
        label: label,
        variant: variant,
        measureLocation: measureLocation,
        progressBarAriaProps: progressBarAriaProps
      }));
    }
  }]);

  return Progress;
}(React.Component);
Progress.defaultProps = {
  className: '',
  measureLocation: ProgressMeasureLocation.top,
  variant: null,
  id: '',
  title: '',
  min: 0,
  max: 100,
  size: null,
  label: null,
  value: 0,
  valueText: null
};